import { VALID_PAY_FREQUENCIES } from "./CalculateMonthlyPay";

interface payRecords {
    is_Duplicate: number;
    Pay_frequency: any;
    End_date?: any;
    Start_date?: any;
}
const AvgPay = (totalNetPay, payRecords: payRecords[]) => {
    if (totalNetPay === 0) return 0;
    if (!payRecords.length) return 0;
    const payRecordsWithoutDuplicate = payRecords.filter((file) => file.is_Duplicate === 0);
    const payRecordsWithValidPayFrequency = payRecordsWithoutDuplicate.filter((file) => file.Pay_frequency?.value === VALID_PAY_FREQUENCIES.Monthly || file.Pay_frequency?.value === VALID_PAY_FREQUENCIES.Bi_Monthly || file.Pay_frequency?.value === VALID_PAY_FREQUENCIES.Bi_Weekly || file.Pay_frequency?.value === VALID_PAY_FREQUENCIES.Weekly);
    const uniqueDateRecords = payRecordsWithValidPayFrequency.filter((record, index, self) =>
        index === self.findIndex((r) => 
            r.Start_date === record.Start_date && 
            r.End_date === record.End_date
        )
    );
    if (!uniqueDateRecords.length) return totalNetPay;

    return totalNetPay / uniqueDateRecords.length;
}

export default AvgPay;